if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');

      this.lastScrollY = window.scrollY;
      this.downAccum = 0;
      this.upAccum = 0;
      this.handleDirectionScroll = this.handleDirectionScroll.bind(this);

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }

      // 前回セッションで閉じられていたら最初から非表示にする
      if (StickyAtcPanel.isDismissed()) {
        this.classList.add('sticky-atc-panel--dismissed');
      }
      this.bindCloseButton();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
      window.removeEventListener('scroll', this.handleDirectionScroll);
    }

    bindEvents() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.productForm && !theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.boundingClientRect.bottom > 0);
          } else if (entry.target === this.productInfo && theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
          }
        });
      });

      if (this.productForm) observer.observe(this.productForm);
      if (this.productInfo) observer.observe(this.productInfo);

      window.addEventListener('scroll', StickyAtcPanel.handleScroll);
      window.addEventListener('scroll', this.handleDirectionScroll, { passive: true });
    }

    /**
     * スクロール方向に連動した表示制御（スマホのみ）。
     * 下方向へ進行=隠す / 上方向へ戻る=出す（ヘッダーナビの逆挙動）。
     * PC では従来どおり IntersectionObserver に委譲する。
     */
    handleDirectionScroll() {
      if (theme.mediaMatches.md) {
        this.classList.remove('sticky-atc-panel--scroll-hidden');
        this.lastScrollY = window.scrollY;
        return;
      }

      const currentY = window.scrollY;
      const delta = currentY - this.lastScrollY;
      this.lastScrollY = currentY;

      // 微小なバウンス(±2px)は方向判定に使わない
      if (Math.abs(delta) < 2) return;

      if (delta > 0) {
        // 下方向: 一定量(64px)連続で進んでから隠す。少しの揺り戻しでは消えない
        this.upAccum = 0;
        this.downAccum += delta;
        if (this.downAccum > 64 && currentY > 160
            && !this.classList.contains('sticky-atc-panel--scroll-hidden')) {
          this.classList.add('sticky-atc-panel--scroll-hidden');
          StickyAtcPanel.nudgeLaunchers();
        }
      } else {
        // 上方向: わずか(16px)戻すだけで出す。出やすく・隠れにくく
        this.downAccum = 0;
        this.upAccum += -delta;
        if (this.upAccum > 16
            && this.classList.contains('sticky-atc-panel--scroll-hidden')) {
          this.classList.remove('sticky-atc-panel--scroll-hidden');
          StickyAtcPanel.nudgeLaunchers();
        }
      }
    }

    /**
     * sticky バーの表示切替後、AR/Growave ランチャーの追従(panel の visibility 連動)を
     * 確実に再計算させる。visibility は transition 遅延で約0.3s後に切り替わるため、
     * 切替直後ともう一度遅延後に scroll を発火して既存の同期処理を起こす。
     */
    static nudgeLaunchers() {
      try {
        window.dispatchEvent(new Event('scroll'));
        setTimeout(function () { window.dispatchEvent(new Event('scroll')); }, 360);
      } catch (_) { /* noop */ }
    }

    bindCloseButton() {
      const closeBtn = this.querySelector('.sticky-atc-panel__close');
      if (!closeBtn) return;
      closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.classList.add('sticky-atc-panel--dismissed');
        StickyAtcPanel.setDismissed();
        StickyAtcPanel.nudgeLaunchers();
      });
    }

    static isDismissed() {
      try {
        return sessionStorage.getItem('artgraph:sticky-atc-dismissed') === '1';
      } catch (_) {
        return false;
      }
    }

    static setDismissed() {
      try {
        sessionStorage.setItem('artgraph:sticky-atc-dismissed', '1');
      } catch (_) { /* sessionStorage 不可環境では無視 */ }
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
